import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import laborUtil from "@/utils/ServiceRequestLaborsUtil";
const actions = {
  saveServiceRequestLabor(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${context.state.serviceRequestLabor.serviceRequestId}/labors`,
          context.state.serviceRequestLabor
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getServiceRequestLabors(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/labors`
        )
        .then(res => {
          if (res.status === 200) {
            const list = laborUtil.restructureLaborList(res.data);
            context.commit("setServiceRequestLabors", list);
            resolve(list);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateServiceRequestLabor(_, payload) {
    if (payload.vendorId === "") {
      delete payload.vendorId;
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/labors/${payload.serviceRequestLaborId}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteServiceRequestLabor(_, payload) {
    return apiHelper.call(
      "delete",
      `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/labors/${payload.serviceRequestLaborId}`
    );
  }
};

export default actions;
